<div class="panel panel-flat">
  <div class="content-group">

    <div class="tabbable">
      <ul class="nav nav-tabs nav-tabs-highlight">
        <li class="active"><a href="#profile-tab" data-toggle="tab"> <i
              class="icon-profile position-left"></i>Profile</a></li>
        <li><a href="#transactions-tab" data-toggle="tab"> <i class="icon-cash position-left"></i>Transactions</a></li>
        <!--  <li><a href="#guarantees-tab" data-toggle="tab"> <i class="icon-collaboration position-left"></i>Guarantees</a> -->
        <li><a href="#awards-tab" data-toggle="tab"> <i class="icon-trophy3 position-left"></i>Awards</a>
        </li>
        <li><a href="#receipts-tab" data-toggle="tab"> <i class="icon-drawer position-left"></i>Receipts</a>
        </li>
        <li><a href="#notifications-tab" data-toggle="tab"> <i class="icon-bell3 position-left"></i>Notifications</a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane has-padding active" id="profile-tab">

          <div class="row">
            <div class="col-md-8">


              <div class="row">
                <div class="col-lg-6">
                  <div class="panel border-left-lg border-left-info invoice-grid timeline-content">
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <h6 class="text-semibold no-margin-top">Full Name:</h6>
                          <ul class="list list-unstyled">
                            <li>Gender:</li>
                            <li>ID/Passport Number:</li>
                            <li>Primary Phone Number:</li>
                            <li>Secondary Phone Number:</li>
                            <li>Emergency Contact:</li>
                            <li>Emergency Phone:</li>
                          </ul>
                        </div>

                        <div class="col-sm-6">
                          <h6 class="text-semibold text-right no-margin-top">{{customer?.full_name}}</h6>
                          <ul class="list list-unstyled text-right">
                            <li><span class="text-semibold">{{customer?.gender}}</span></li>
                            <li><span class="text-semibold">{{customer?.id_passport_number}}</span></li>
                            <li><span class="text-semibold">{{customer?.phone_number_1}}</span></li>
                            <li><span class="text-semibold">{{customer?.phone_number_2}}</span></li>
                            <li><span class="text-semibold">{{customer?.emergency_contact}}</span></li>
                            <li><span class="text-semibold">{{customer?.emergency_phone}}</span></li>
                            <!-- <li class="dropdown">
                              Status: &nbsp;
                              <a href="#" class="label bg-danger-400 dropdown-toggle" data-toggle="dropdown">Overdue
                                <span class="caret"></span></a>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li class="active"><a href="#"><i class="icon-alert"></i> Overdue</a></li>
                                <li><a href="#"><i class="icon-alarm"></i> Pending</a></li>
                                <li><a href="#"><i class="icon-checkmark3"></i> Paid</a></li>
                                <li class="divider"></li>
                                <li><a href="#"><i class="icon-spinner2 spinner"></i> On hold</a></li>
                                <li><a href="#"><i class="icon-cross2"></i> Canceled</a></li>
                              </ul>
                            </li> -->
                          </ul>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="panel border-left-lg border-left-info invoice-grid timeline-content">
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <h6 class="text-semibold no-margin-top">Email</h6>
                          <ul class="list list-unstyled">
                            <li>Region:</li>
                            <li>City:</li>
                            <li>Subcity:</li>
                            <li>Woreda/Kebele:</li>
                            <li>House Number:</li>
                            <li>Ekubs Count:</li>
                          </ul>
                        </div>

                        <div class="col-sm-6">
                          <h6 class="text-semibold text-right no-margin-top">{{customer?.email}}</h6>
                          <ul class="list list-unstyled text-right">
                            <li><span class="text-semibold">{{customer?.region}}</span></li>
                            <li><span class="text-semibold">{{customer?.city}}</span></li>
                            <li><span class="text-semibold">{{customer?.sub_city}}</span></li>
                            <li><span class="text-semibold">{{customer?.woreda_kebele}}</span></li>
                            <li><span class="text-semibold">{{customer?.house_no}}</span></li>
                            <li><span class="text-semibold">{{customer?.ekubs.length}}</span></li>
                            <!--  <li class="dropdown">
                              Status: &nbsp;
                              <a href="#" class="label bg-danger-400 dropdown-toggle" data-toggle="dropdown">Overdue
                                <span class="caret"></span></a>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li class="active"><a href="#"><i class="icon-alert"></i> Overdue</a></li>
                                <li><a href="#"><i class="icon-alarm"></i> Pending</a></li>
                                <li><a href="#"><i class="icon-checkmark3"></i> Paid</a></li>
                                <li class="divider"></li>
                                <li><a href="#"><i class="icon-spinner2 spinner"></i> On hold</a></li>
                                <li><a href="#"><i class="icon-cross2"></i> Canceled</a></li>
                              </ul>
                            </li> -->
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>


              </div>



              <h6>CUSTOMER EKUBS</h6>
              <hr>
              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Start Date</th>
                    <th>Joined</th>
                    <th>Total Members</th>
                    <th>Code</th>
                    <th> Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let ekub of customerEkubs">
                    <td>
                      <div class="media">
                        <div class="media-left">{{ekub.ekub_id}}
                        </div>
                      </div>
                    </td>
                    <td>{{ekub.start_date|date:short}}</td>
                    <td>{{ekub?.pivot?.created_at|date: 'MMM d, y, h:mm:ss a'}}</td>
                    <td>{{ekub.total_members}}</td>
                    <td>{{ekub?.pivot?.code}}</td>
                    <td>
                      <span class="label label-block label-default"
                        *ngIf="ekub.pivot.status === 'Pending' || ekub.pivot.status === 'pending'">{{ekub.pivot.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="ekub.pivot.status === 'Active' || ekub.pivot.status === 'active'">{{ekub.pivot.status}}</span>
                      <span class="label label-block label-success"
                        *ngIf="ekub.pivot.status === 'Qualified' || ekub.pivot.status === 'qualified'">{{ekub.pivot.status}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="ekub.pivot.status === 'Disqualified' || ekub.pivot.status === 'disqualified'">{{ekub.pivot.status}}</span>
                      <span class="label label-block bg-royal-400"
                        *ngIf="ekub.pivot.status === 'Won' || ekub.pivot.status === 'won'">{{ekub.pivot.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="javascript:void(0);">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'active')">
                                    <i class="icon-shuffle"></i> Active</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'qualified')">
                                    <i class="icon-shuffle"></i> Qualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'disqualified')">
                                    <i class="icon-shuffle"></i> Disqualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'won')">
                                    <i class="icon-shuffle"></i> Won</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br>
              <br>

              <br>


              <h6>RECENT TRANSACTIONS</h6>
              <hr>
              <div class="row">
                <div class="col-md-3 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-3 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-3 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>
              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Type</th>
                    <th>Transaction Date</th>
                    <th>Transaction Number</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let trxn of customerTransactions">
                    <td>
                      {{trxn?.ekub.data.ekub_id}} - {{trxn.code}}
                    </td>
                    <td><span class="text-uppercase"
                        [ngClass]="{'text-danger': trxn.type == 'fine', 'text-primary': trxn.type == 'deposit','text-brown': trxn.type == 'award' }">{{trxn.type}}</span>
                    </td>
                    <td>
                      {{trxn.transaction_date|date:short}}

                    </td>
                    <td>{{trxn.transaction_number}}</td>
                    <td>
                      {{trxn?.amount|number:'1.2-2'}} ETB
                    </td>
                    <td>
                      <span class="label label-block label-default"
                        *ngIf="trxn.status === 'Pending' || trxn.status === 'pending'">{{trxn.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="trxn.status === 'Confirmed' || trxn.status === 'confirmed'">{{trxn.status}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="trxn.status === 'Declined' || trxn.status === 'declined'">{{trxn.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a (click)="changeTrxnStatus(trxn.id,'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a (click)="changeTrxnStatus(trxn.id,'confirmed')">
                                    <i class="icon-shuffle"></i> Confirmed</a>
                                </li>
                                <li>
                                  <a (click)="changeTrxnStatus(trxn.id,'declined')">
                                    <i class="icon-shuffle"></i> Declined</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div class="col-md-4">

              <div class="panel panel-white">
                <!-- <div class="panel-heading">
                      <h4 class="panel-title">Customer Pictures</h4>
                    </div> -->
                <div class="panel-body no-padding-bottom">

                  <div class="">
                    <h6>Profile Picture</h6>
                    <hr>
                    <div class="">
                      <div class="thumb thumb-rounded text-center">
                        <img *ngIf="!customer?.user?.data?.avatar" src="assets/img/userm.png" width="100" height="100"
                          class="img-circle img-md" alt="">
                        <img *ngIf="customer?.user?.data?.avatar"
                          [src]="baseUrl+'assets/'+customer?.user?.data?.avatar+'/render'" alt="Profile Imag"
                          class="profileImg img-responsive">
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6>Id Front</h6>
                    <hr>

                    <div class="well" style="min-height: 250px;">
                      <!-- <img [src]="legalIdFrontUrl" alt="ID Front" class="profileImg img-responsive"> -->
                      <img [src]="baseUrl+'assets/'+customer?.user?.data?.id_front+'/render'" alt="ID Front"
                        class="profileImg img-responsive">

                    </div>

                    <div>
                      <h6>Id Back</h6>
                      <hr>
                      <div class="well" style="min-height: 250px;">
                        <!-- <img [src]="legalIdBackUrl" alt="ID Back" class="profileImg img-responsive"> -->
                        <img [src]="baseUrl+'assets/'+customer?.user?.data?.id_back+'/render'" alt="ID Back"
                          class="profileImg img-responsive">

                      </div>
                    </div>
                    <br>

                  </div>
                </div>

              </div>

            </div>

          </div>


        </div>

        <div class="tab-pane has-padding" id="transactions-tab">



          <!-- Quick stats boxes -->
          <div class="row">
            <div class="col-lg-3">

              <!-- Members online -->
              <div class="panel bg-light-400">
                <div class="panel-body">
                  <div class="heading-elements">
                    <!-- <span class="heading-text badge bg-teal-800">+53,6%</span> -->
                    <ul class="icons-list">
                      <li>
                        <a data-action="reload"></a>
                      </li>
                    </ul>
                  </div>

                  <h3 class="no-margin">{{userStats?.total_ekubs|number:'1.0-2'}}</h3>
                  <strong>Total Ekubs</strong>
                  <div class="text-size-small">0 active ekubs</div>
                </div>

                <div class="container-fluid">
                  <div id="members-online"></div>
                </div>
              </div>
              <!-- /members online -->

            </div>

            <div class="col-lg-3">

              <!-- Current server load -->
              <div class="panel bg-light-400">
                <div class="panel-body">
                  <div class="heading-elements">
                    <ul class="icons-list">
                      <li>
                        <a data-action="reload"></a>
                      </li>
                    </ul>
                  </div>

                  <h3 class="no-margin">{{userStats?.total_balance|number:'1.0-2'}}</h3>
                  <strong>Total Balance</strong>
                  <div class=" text-size-small">Pending transactions - 0 ETB </div>
                </div>

                <div id="server-load"></div>
              </div>
              <!-- /current server load -->

            </div>

            <div class="col-lg-3">

              <!-- Today's revenue -->
              <div class="panel bg-light-400">
                <div class="panel-body">
                  <div class="heading-elements">
                    <ul class="icons-list">
                      <li>
                        <a data-action="reload"></a>
                      </li>
                    </ul>
                  </div>

                  <h3 class="no-margin">{{userStats?.total_awards|number:'1.0-2'}}</h3>
                  <strong>Total Awards</strong>
                  <div class="text-size-small">Estimated value - 0 ETB
                  </div>
                </div>

                <div id="today-revenue"></div>
              </div>
              <!-- /today's revenue -->

            </div>


            <div class="col-lg-3">

              <!-- Today's revenue -->
              <div class="panel bg-light-700">
                <div class="panel-body">
                  <div class="heading-elements">
                    <ul class="icons-list">
                      <li>
                        <a data-action="reload"></a>
                      </li>
                    </ul>
                  </div>

                  <h3 class="no-margin">{{userStats?.total_awards|number:'1.0-2'}}</h3>
                  <strong>Total Penality</strong>
                  <div class="text-size-small">Estimated value - 0 ETB
                  </div>
                </div>

                <div id="today-revenue"></div>
              </div>
              <!-- /today's revenue -->

            </div>

          </div>
          <!-- /quick stats boxes -->

          <div class="row">
            <div class="col-md-12">

              <h6>TRANSACTIONS</h6>
              <hr>
              <div class="row">
                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>
              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Type</th>
                    <th>Transaction Date</th>
                    <th>Transaction Number</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>

                  <tr
                    *ngFor="let trxn of customerTransactions | paginate: { id: 'transactions',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>
                      {{trxn?.ekub.data.ekub_id}} - {{trxn.code}}
                    </td>
                    <td><span class="text-uppercase"
                        [ngClass]="{'text-danger': trxn.type == 'fine', 'text-primary': trxn.type == 'deposit','text-brown': trxn.type == 'award' }">{{trxn.type}}</span>
                    </td>
                    <td>
                      {{trxn.transaction_date|date:short}}

                    </td>
                    <td>{{trxn.transaction_number}}</td>
                    <td>
                      {{trxn?.amount|number:'1.2-2'}} ETB
                    </td>
                    <td>
                      <span class="label label-block label-default"
                        *ngIf="trxn.status === 'Pending' || trxn.status === 'pending'">{{trxn.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="trxn.status === 'Confirmed' || trxn.status === 'confirmed'">{{trxn.status}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="trxn.status === 'Declined' || trxn.status === 'declined'">{{trxn.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a (click)="changeTrxnStatus(trxn.id,'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a (click)="changeTrxnStatus(trxn.id,'confirmed')">
                                    <i class="icon-shuffle"></i> Confirmed</a>
                                </li>
                                <li>
                                  <a (click)="changeTrxnStatus(trxn.id,'declined')">
                                    <i class="icon-shuffle"></i> Declined</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="customerTransactions?.length <= 0">
                    <td class="text-center" colspan="7">No Transactions yet</td>
                  </tr>
                </tbody>
              </table>



              <div class="row" *ngIf="customerTransactions?.length > 0">
                <div class="text-center">

                  <pagination-controls id="transactions"
                    (pageChange)="pageChanged(currentPage = $event, 'transactions')">
                  </pagination-controls>

                  <br>
                </div>

              </div>


              <br>
              <br>

              <br>



              <h6>SALES</h6>
              <hr>
              <div class="row">
                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>


              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Amount</th>
                    <th>Code</th>
                    <th>Draw Date</th>
                    <th> Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let sale of sales | paginate: { id: 'sales',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>
                      <div class="media">
                        <div class="media-left">{{sale.award?.data?.ekub?.data.ekub_id}}
                        </div>
                      </div>
                    </td>
                    <td>{{sale?.award?.data.amount|number:'1.2-2'}} ETB</td>
                    <td>{{sale?.award?.data?.code}}</td>
                    <td>{{sale?.award?.data.draw_date|date:short}}</td>
                    <td>
                      <span class="label label-block label-success"
                        *ngIf="sale.status === 'Scheduled' || sale.status === 'scheduled'">{{sale.status}}</span>
                      <span class="label label-block label-default"
                        *ngIf="sale.status === 'Pending' || sale.status === 'pending'">{{sale.status}}</span>
                      <span class="label label-block bg-royal-400"
                        *ngIf="sale.status === 'Initialized' || sale.status === 'initialized'">{{sale.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="sale.status === 'Drawed' || sale.status === 'drawed'">{{sale.status}}</span>
                      <span class="label label-block bg-grey"
                        *ngIf="sale.status === 'Received' || sale.status === 'received'">{{sale.status}}</span>
                      <span class="label label-block bg-teal"
                        *ngIf="sale.status === 'sold' || sale.status === 'sold'">{{sale.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'active')">
                                    <i class="icon-shuffle"></i> Active</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'qualified')">
                                    <i class="icon-shuffle"></i> Qualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'disqualified')">
                                    <i class="icon-shuffle"></i> Disqualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'won')">
                                    <i class="icon-shuffle"></i> Won</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="sales?.length <= 0">
                    <td class="text-center" colspan="6">No Sales yet</td>
                  </tr>
                </tbody>
              </table>


              <div class="row" *ngIf="sales?.length > 0">
                <div class="text-center">

                  <pagination-controls id="sales" (pageChange)="pageChanged(currentPage = $event, 'sales')">
                  </pagination-controls>

                  <br>
                </div>

              </div>

              <br>
              <br>

              <br>


              <h6>OFFERS</h6>
              <hr>

              <div class="row">
                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>

              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Amount</th>
                    <th>Code</th>
                    <th>Draw Date</th>
                    <th> Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>

                  <tr
                    *ngFor="let award of offers | paginate: { id: 'offers',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>
                      <div class="media">
                        <div class="media-left">{{award?.ekub?.data?.ekub_id}}
                        </div>
                      </div>
                    </td>
                    <td>{{award?.amount|number:'1.2-2'}} ETB</td>
                    <td>{{award?.code}}</td>
                    <td>{{award?.draw_date | date:short}}</td>
                    <td>
                      <span class="label label-block label-success"
                        *ngIf="award.status === 'Scheduled' || award.status === 'scheduled'">{{award.status}}</span>
                      <span class="label label-block label-default"
                        *ngIf="award.status === 'Pending' || award.status === 'pending'">{{award.status}}</span>
                      <span class="label label-block bg-royal-400"
                        *ngIf="award.status === 'Initialized' || award.status === 'initialized'">{{award.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="award.status === 'Drawed' || award.status === 'drawed'">{{award.status}}</span>
                      <span class="label label-block bg-grey"
                        *ngIf="award.status === 'Received' || award.status === 'received'">{{award.status}}</span>
                      <span class="label label-block bg-teal"
                        *ngIf="award.status === 'sold' || award.status === 'sold'">{{award.status}}</span>
                    </td>
                    <!-- <td>
                      <span class="label label-block label-warning"
                        *ngIf="award.status === 'Pending' || award.status === 'pending'">{{award.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="award.status === 'Active' || award.status === 'active'">{{award.status}}</span>
                      <span class="label label-block label-success"
                        *ngIf="award.status === 'Qualified' || award.status === 'qualified'">{{award.status}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="award.status === 'Disqualified' || award.status === 'disqualified'">{{award.status}}</span>
                      <span class="label label-block bg-brown"
                        *ngIf="award.status === 'Won' || award.status === 'won'">{{award.status}}</span>
                    </td> -->
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'active')">
                                    <i class="icon-shuffle"></i> Active</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'qualified')">
                                    <i class="icon-shuffle"></i> Qualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'disqualified')">
                                    <i class="icon-shuffle"></i> Disqualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'won')">
                                    <i class="icon-shuffle"></i> Won</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="offers?.length <= 0">
                    <td class="text-center" colspan="6">No Offers yet</td>
                  </tr>
                </tbody>
              </table>


              <div class="row" *ngIf="offers?.length > 0">
                <div class="text-center">

                  <pagination-controls id="offers" (pageChange)="pageChanged(currentPage = $event,'offers')">
                  </pagination-controls>

                  <br>
                </div>

              </div>




            </div>

          </div>



        </div>


        <div class="tab-pane has-padding" id="awards-tab">


          <div class="row">
            <div class="col-md-12">

              <!--  <h6> GUARANTOR FOR</h6> -->
              <h6> AWARDS</h6>
              <hr>
              <div class="row">
                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>

              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Amount</th>
                    <th>Code</th>
                    <th>Draw Date</th>
                    <th> Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>

                  <tr
                    *ngFor="let award of awards | paginate: { id: 'awards',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>
                      <div class="media">
                        <div class="media-left">{{award?.ekub?.data?.ekub_id}}
                        </div>
                      </div>
                    </td>
                    <td>{{award?.amount|number:'1.2-2'}} ETB</td>
                    <td>{{award?.code}}</td>
                    <td>{{award?.draw_date | date:short}}</td>
                    <td>
                      <span class="label label-block label-success"
                        *ngIf="award.status === 'Scheduled' || award.status === 'scheduled'">{{award.status}}</span>
                      <span class="label label-block label-default"
                        *ngIf="award.status === 'Pending' || award.status === 'pending'">{{award.status}}</span>
                      <span class="label label-block bg-royal-400"
                        *ngIf="award.status === 'Initialized' || award.status === 'initialized'">{{award.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="award.status === 'Drawed' || award.status === 'drawed'">{{award.status}}</span>
                      <span class="label label-block bg-grey"
                        *ngIf="award.status === 'Received' || award.status === 'received'">{{award.status}}</span>
                      <span class="label label-block bg-teal"
                        *ngIf="award.status === 'sold' || award.status === 'sold'">{{award.status}}</span>
                    </td>
                    <!-- <td>
                      <span class="label label-block label-warning"
                        *ngIf="award.status === 'Pending' || award.status === 'pending'">{{award.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="award.status === 'Active' || award.status === 'active'">{{award.status}}</span>
                      <span class="label label-block label-success"
                        *ngIf="award.status === 'Qualified' || award.status === 'qualified'">{{award.status}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="award.status === 'Disqualified' || award.status === 'disqualified'">{{award.status}}</span>
                      <span class="label label-block bg-brown"
                        *ngIf="award.status === 'Won' || award.status === 'won'">{{award.status}}</span>
                    </td> -->
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'active')">
                                    <i class="icon-shuffle"></i> Active</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code,'qualified')">
                                    <i class="icon-shuffle"></i> Qualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'disqualified')">
                                    <i class="icon-shuffle"></i> Disqualified</a>
                                </li>
                                <li>
                                  <a
                                    (click)="changeStatus(ekub.pivot.ekub_id,ekub.pivot.user_id, ekub.pivot.code, 'won')">
                                    <i class="icon-shuffle"></i> Won</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="awards?.length <= 0">
                    <td class="text-center" colspan="6">Not awards yet</td>
                  </tr>
                </tbody>
              </table>


              <div class="row" *ngIf="awards?.length > 0">
                <div class="text-center">

                  <pagination-controls id="awards" (pageChange)="pageChanged(currentPage = $event, 'awards')">
                  </pagination-controls>

                  <br>
                </div>

              </div>


              <br>
              <br>

              <br>







              <h6> GUARANTOR FOR</h6>
              <hr>
              <div class="row">
                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>

              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Ekub</th>
                    <th>Winner</th>
                    <th>Amount</th>
                    <th>Code</th>
                    <th>Draw Date</th>
                    <th>Ref. Number</th>
                    <th> Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>

                  <tr
                    *ngFor="let gurantee of guarantees | paginate: { id: 'gurantees',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>
                      <div class="media">
                        <div class="media-left">{{gurantee?.award?.data?.ekub?.data?.ekub_id}}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="media-left">
                        <a href=""
                          [routerLink]="['/user',gurantee?.award?.data?.winner?.data?.id]">{{gurantee?.award?.data?.winner?.data?.username}}
                          <div class="text-muted text-size-small">
                            {{gurantee?.award?.data?.winner?.data?.email}}
                          </div>
                        </a>
                      </div>
                    </td>
                    <td>{{gurantee?.award?.data?.amount|number:'1.2-2'}} ETB</td>
                    <td>{{gurantee?.award?.data?.code}}</td>
                    <td>{{gurantee?.award?.data.draw_date | date:short}}</td>
                    <td>{{gurantee?.ref_number}}</td>
                    <td>
                      <span class="label label-block label-success"
                        *ngIf="gurantee.status === 'Paid' || gurantee.status === 'paid'">{{gurantee.status}}</span>
                      <span class="label label-block label-default"
                        *ngIf="gurantee.status === 'Pending' || gurantee.status === 'pending'">{{gurantee.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="gurantee.status === 'Active' || gurantee.status === 'active'">{{gurantee.status}}</span>
                      <span class="label label-block bg-danger"
                        *ngIf="gurantee.status === 'Defaulted' || gurantee.status === 'defaulted'">{{gurantee.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a (click)="changeGuaranteeStatus(gurantee.id, 'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a (click)="changeGuaranteeStatus(gurantee.id,'active')">
                                    <i class="icon-shuffle"></i> Active</a>
                                </li>
                                <li>
                                  <a (click)="changeGuaranteeStatus(gurantee.id, 'paid')">
                                    <i class="icon-shuffle"></i> Paid</a>
                                </li>
                                <li>
                                  <a (click)="changeGuaranteeStatus(gurantee.id, 'defaulted')">
                                    <i class="icon-shuffle"></i> Defaulted</a>
                                </li>

                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="guarantees?.length <= 0">
                    <td class="text-center" colspan="8">Not a Guarantor yet</td>
                  </tr>
                </tbody>
              </table>


              <div class="row" *ngIf="guarantees?.length > 0">
                <div class="text-center">

                  <pagination-controls id="gurantees" (pageChange)="pageChanged(currentPage = $event)">
                  </pagination-controls>

                  <br>
                </div>

              </div>




              <br>
              <br>

              <br>



              <h6>OBLIGED BY</h6>
              <hr>


              <div class="row">
                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Status</span>
                  <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="?status=" selected>All</option>
                    <option value="?status=pending">Pending</option>
                    <option value="?status=confirmed">Confirmed</option>
                    <option value="?status=declined">Declined</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span style="float:left" class="control-label">Filter by: Type</span>
                  <select name="status" required [(ngModel)]="typeFilter" (ngModelChange)="getTransactionFilter()"
                    class="form-control">
                    <option value="" selected>All</option>
                    <option value="&type=deposit">Deposit</option>
                    <option value="&type=fine">Fine</option>
                    <option value="&type=award">Award</option>
                  </select>
                </div>

                <div class="col-md-2 form-group required">
                  <span class="control-label">&nbsp; </span>
                </div>
              </div>

              <!-- 

              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th class="text-center">Type</th>
                    <th>Ref Number</th>
                    <th>Guarantee Date</th>
                    <th>Remark</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody class="table-body" *ngFor="let award of awards; index as i">

                  <tr class="" data-toggle="collapse" [attr.data-target]="'#demo' + i">
                    <td>
                      <div class="media">
                        <div class="media-left">{{award?.ekub?.data?.ekub_id}}
                        </div>
                      </div>
                    </td>
                    <td>{{award?.amount|number:'1.2-2'}} ETB</td>
                    <td>{{award?.code}}</td>
                    <td>{{award?.draw_date | date:short}}</td>
                    <td>
                      {{award?.remark}}<span class="label label-success"
                        *ngIf="award.status === 'Scheduled' || award.status === 'scheduled'">{{award.status}}</span>
                      <span class="label label-default"
                        *ngIf="award.status === 'Pending' || award.status === 'pending'">{{award.status}}</span>
                      <span class="label bg-royal-400"
                        *ngIf="award.status === 'Initialized' || award.status === 'initialized'">{{award.status}}</span>
                      <span class="label label-primary"
                        *ngIf="award.status === 'Drawed' || award.status === 'drawed'">{{award.status}}</span>
                      <span class="label bg-grey"
                        *ngIf="award.status === 'Received' || award.status === 'received'">{{award.status}}</span>
                      <span class="label bg-teal"
                        *ngIf="award.status === 'sold' || award.status === 'sold'">{{award.status}}</span>
                    </td>
                  </tr>
                  <tr *ngFor="let guarantee of award.guarantees.data" id="demo{{i}}" class="collapse in row-child">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Ref Number</th>
                        <th>Guarantee Date</th>
                        <th>Remark</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <td class="text-center" colspan="1"><i class="fa fa-angle-up"></i></td>
                    <td>
                      <div class="media">
                        <div class="media-left">{{guarantee?.type}}
                        </div>
                      </div>
                    </td>
                    <td>{{guarantee?.ref_number}} ETB</td>
                    <td>{{guarantee?.created_at | date:short}}</td>
                    <td>{{guarantee?.remark}}</td>
                  </tr>
                </tbody>
              </table>
 -->

              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Award</th>
                    <th>Guarantees</th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <!-- <tr *ngFor="let award of awards;index as i" > -->
                  <tr
                    *ngFor="let award of awards | paginate: { id: 'obligedGuarantees',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems };index as i">
                    <td>
                      <div class="media-left">
                        <a href=""
                          [routerLink]="['/user',gurantee?.award?.data?.winner?.data?.id]">{{award?.ekub?.data?.ekub_id}}
                          <div class="text-muted text-size-small">
                            {{award?.draw_date | date:short}} - {{award?.code}} - {{award?.amount}} ETB
                          </div>
                        </a>
                      </div>
                    </td>

                    <td>
                      <table class="table datatable-column-search-inputs">
                        <thead>
                          <tr>
                            <th class="text-center">Type</th>
                            <th>Ref Number</th>
                            <th>Amount Guaranteed</th>
                            <th>Guarantee Date</th>
                            <th>Remark</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody class="table-body">
                          <tr *ngFor="let guarantee of award.guarantees.data">
                            <td>
                              <div class="media">
                                <div class="media-left">{{guarantee?.type}}
                                </div>
                              </div>
                            </td>
                            <td>{{guarantee?.ref_number}}</td>
                            <td>{{guarantee?.amount_guaranteed|number:'1.2-2'}} ETB</td>
                            <td>{{guarantee?.created_at | date:short}}</td>
                            <td>{{guarantee?.remark}}</td>
                            <td>
                              <span class="label label-block label-success"
                                *ngIf="guarantee.status === 'Paid' || guarantee.status === 'paid'">{{guarantee.status}}</span>
                              <span class="label label-block label-default"
                                *ngIf="guarantee.status === 'Pending' || guarantee.status === 'pending'">{{guarantee.status}}</span>
                              <span class="label label-block label-primary"
                                *ngIf="guarantee.status === 'Active' || guarantee.status === 'active'">{{guarantee.status}}</span>
                              <span class="label label-block bg-danger"
                                *ngIf="guarantee.status === 'Defaulted' || guarantee.status === 'defaulted'">{{guarantee.status}}</span>
                            </td>
                          </tr>
                          <tr *ngIf="award.guarantees.data.length <= 0">
                            <td class="text-center" colspan="6">No Guarantees Added</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>


              <div class="row" *ngIf="awards?.length > 0">
                <div class="text-center">

                  <pagination-controls id="obligedGuarantees" (pageChange)="pageChanged(currentPage = $event)">
                  </pagination-controls>

                  <br>
                </div>

              </div>


              <br>
              <br>

              <br>



            </div>



          </div>




        </div>

        <div class="tab-pane has-padding" id="notifications-tab">



          <div class="row">

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Date</span>
              <input type="date" name="notificationDate" class="form-control" />
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Type</span>
              <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getNotificationsFilter()"
                class="form-control">
                <option value="&type=">All</option>
                <option value="&type=info">Info</option>
                <option value="&type=warning">Inactive</option>
                <option value="&type=danger">Danger</option>
              </select>
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Status</span>
              <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getNotificationsFilter()"
                class="form-control">
                <option value="&status=">All</option>
                <option value="&status=read">Active</option>
                <option value="&status=unread">Inactive</option>
              </select>
            </div>

            <div class="col-md-6 form-group required">
              <span class="control-label">&nbsp; </span>
              <div class="btn-group pull-right">
                <a data-toggle="modal" data-target="#notificationModal" type="button"
                  class="btn btn-icon btn-sm bg-slate-800 btn-rounded" id="openNotificationModal">
                  <i class="icon-add position-left"></i> Add Notification</a>
                <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                  <i class="icon-printer position-left"></i>Print</a>
              </div>
            </div>


          </div>

          <div class="panel-body">





            <div class="row">
              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let notification of notifications | paginate: { id: 'notifications',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>{{notification.title}}</td>
                    <td>{{notification.content}}</td>
                    <td>{{notification.created_at | date: 'MMM d, y, h:mm:ss a'}}</td>
                    <td>
                      <span class="label label-block label-primary"
                        *ngIf="notification.type === 'Info' || notification.type === 'info'">{{notification.type}}</span>
                      <span class="label label-block label-warning"
                        *ngIf="notification.type === 'Warning' || notification.type === 'warning'">{{notification.type}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="notification.type === 'Danger' || notification.type === 'danger'">{{notification.type}}</span>
                    </td>
                    <td>
                      <span class="label label-block label-default"
                        *ngIf="notification.status === 'Read' || notification.status === 'read'">{{notification.status}}</span>
                      <span class="label label-block label-primary"
                        *ngIf="notification.status === 'Unread' || notification.status === 'unread'">{{notification.status}}</span>
                      <span class="label label-block bg-brown"
                        *ngIf="notification.status === 'Pending' || notification.status === 'pending'">{{notification.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>

                          <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                              <a (click)="setNotification(notification)" data-toggle="modal"
                                data-target="#notificationModal">
                                <i class="icon-file-pdf"></i>Update</a>
                            </li>
                            <li>
                              <a href="">
                                <i class="icon-file-excel"></i>Delete</a>
                            </li>
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a (click)="changeNotificationStatus(notification.id,'read')">
                                    <i class="icon-shuffle"></i> Read</a>
                                </li>
                                <li>
                                  <a (click)="changeNotificationStatus(notification.id,'unread')">
                                    <i class="icon-shuffle"></i> Unread</a>
                                </li>
                                <li>
                                  <a (click)="changeNotificationStatus(notification.id,'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="notifications?.length <= 0">
                    <td colspan="7" class="text-center"> No Notifications Found</td>
                  </tr>
                </tbody>
              </table>
            </div>


            <div class="row" *ngIf="notifications?.length > 0">
              <div class="text-center">

                <pagination-controls id="notifications" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>





          </div>


        </div>

        <div class="tab-pane has-padding" id="receipts-tab">

          <div class="row">
            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Date</span>
              <input type="date" name="notificationDate" class="form-control" />
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Ekub</span>
              <select name="status" required [(ngModel)]="ekubFilter" (ngModelChange)="getReceiptsFilter()"
                class="form-control">
                <option value="&ekub=">All</option>
                <option *ngFor="let ekub of customerEkubs" value="&ekub={{ekub?.id}}">{{ekub?.ekub_id}}</option>
              </select>
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: Status</span>
              <select name="status" required [(ngModel)]="receiptStatusFilter" (ngModelChange)="getReceiptsFilter()"
                class="form-control">
                <option value="&status=">All</option>
                <option value="&status=pending">Pending</option>
                <option value="&status=collected">Collected</option>
                <option value="&status=disposed">Disposed</option>
              </select>
            </div>

            <div class="col-md-6 form-group required">
              <span class="control-label">&nbsp; </span>
              <div class="btn-group pull-right">
                <a data-toggle="modal" data-target="#receiptModal" type="button"
                  class="btn btn-icon btn-sm bg-slate-800 btn-rounded" id="openReceiptModal">
                  <i class="icon-add position-left"></i> Add Receipt</a>
                <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                  <i class="icon-printer position-left"></i>Print</a>
              </div>
            </div>

          </div>

          <div class="panel-body">

            <div class="row">
              <table class="table datatable-column-search-inputs">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Issued Date</th>
                    <th>Amount</th>
                    <th>VAT</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let receipt of receipts | paginate: { id: 'receipts',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                    <td>
                      <div class="media">
                        <span class="media-left">
                          <i *ngIf="!receipt?.file" class="icon-notebook position-left"></i>
                          <a href="javascript:void(0)" (click)="setReceiptUrl(receipt?.file)" data-toggle="modal"
                            data-target="#receiptPicModal">
                            <img *ngIf="receipt?.file" [src]="baseUrl+'assets/'+receipt?.file+'/render'" width="40"
                              height="40" class="img-circle img-md" alt="">
                          </a>
                        </span>
                        <div class="media-left">
                          <a href="" [routerLink]="['/ekub',receipt?.ekub.data.id]">{{receipt?.ekub.data.ekub_id}}
                            <div class="text-muted text-size-small">
                              {{receipt?.ref_number}}
                            </div>
                          </a>
                        </div>
                      </div>
                    </td>
                    <td>{{receipt.issued_date | date: 'MMM d, y, h:mm:ss a'}}</td>
                    <td>{{receipt.amount}} ETB</td>
                    <td>{{receipt.vat}} ETB</td>
                    <td>{{receipt.total}} ETB</td>
                    <td>
                      <span class="label label-block bg-brown"
                        *ngIf="receipt.status === 'Collected' || receipt.status === 'collected'">{{receipt.status}}</span>
                      <span class="label label-block label-danger"
                        *ngIf="receipt.status === 'Disposed' || receipt.status === 'disposed'">{{receipt.status}}</span>
                      <span class="label label-block label-default"
                        *ngIf="receipt.status === 'Pending' || receipt.status === 'pending'">{{receipt.status}}</span>
                    </td>
                    <td class="text-center">
                      <ul class="icons-list">
                        <li class="dropdown">
                          <a href="" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="icon-menu9"></i>
                          </a>

                          <ul class="dropdown-menu dropdown-menu-right">
                            <li>
                              <a (click)="setReceipt(receipt)" data-toggle="modal" data-target="#receiptModal">
                                <i class="icon-file-pdf"></i>Update</a>
                            </li>
                            <li>
                              <a href="">
                                <i class="icon-trash"></i>Delete</a>
                            </li>
                            <li class="dropdown-submenu dropdown-submenu-left">
                              <a href="#">Change Status</a>
                              <ul class="dropdown-menu">
                                <li>
                                  <a (click)="changeReceiptStatus(receipt.id,'pending')">
                                    <i class="icon-shuffle"></i> Pending</a>
                                </li>
                                <li>
                                  <a (click)="changeReceiptStatus(receipt.id,'collected')">
                                    <i class="icon-shuffle"></i> Collected</a>
                                </li>
                                <li>
                                  <a (click)="changeReceiptStatus(receipt.id,'disposed')">
                                    <i class="icon-shuffle"></i> Disposed</a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr *ngIf="receipts?.length <= 0">
                    <td colspan="7" class="text-center"> No Receipts Found</td>
                  </tr>
                </tbody>
              </table>
            </div>




          </div>

        </div>

      </div>
    </div>














  </div>







  <!-- Notification modal -->
  <div id="notificationModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="modal-title"><span *ngIf="notification?.id">Update</span><span *ngIf="!notification?.id">Add</span>
            Notification</h5>
        </div>
        <hr>
        <form name="notificationForm" [formGroup]="notificationForm" novalidate>
          <div class="modal-body">

            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <label>Title</label>
                  <input type="text" placeholder="Notification title" class="form-control" formControlName="title">
                </div>
                <div class="col-sm-12">
                  <label>&nbsp;</label><br>
                  <label>Message:</label>
                  <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="content"
                    placeholder="Notification content. . ."></textarea>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-sm-6 required">
                  <span class="control-label">Type: </span>
                  <select name="type" required formControlName="type" class="form-control"
                    data-placeholder="Select notification type">
                    <option value="info">Info</option>
                    <option value="warning">Warning</option>
                    <option value="danger">Danger</option>
                  </select>
                  <div class="help-block" *ngIf="type.invalid && (type.dirty || type.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Notification Type is required.
                    </p>
                  </div>
                </div>
                <div class="col-sm-6 required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select ekub status">
                    <option value="read">Read</option>
                    <option value="unread">Unread</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Ekub status is required.
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
            <button (click)="addNotification(notification.id)" data-dismiss="modal"
              class="btn btn-rounded bg-slate-800"><i class="icon-add position-left"></i><span
                *ngIf="notification?.id">Update</span><span *ngIf="!notification?.id">Add</span>
              Notification</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Notification modal -->



  <!-- Receipt form modal -->
  <div id="receiptModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="modal-title">Add Receipt</h5>
        </div>

        <form name="receiptForm" [formGroup]="receiptForm" novalidate>
          <div class="modal-body">
            <div class="row">

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label"> Equb: </span>
                  <ng-select [items]="customerEkubs" placeholder="" formControlName="ekub" bindValue="id"
                    bindLabel="ekub_id" required>
                  </ng-select>
                  <div class="help-block" *ngIf="ekub.invalid && (ekub.dirty && ekub.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Equb is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Ref. Number: </span>
                  <input type="text" name="ref_number" formControlName="ref_number" placeholder="Receipt Ref. Number"
                    class="form-control">
                  <div class="help-block"></div>
                  <div class="help-block" *ngIf="ref_number.invalid && (ref_number.dirty || ref_number.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Receipt Reference Number is required
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <span class="control-label"> Issued Date: </span>
                  <input type="date" name="issued_date" formControlName="issued_date" placeholder="Issued Date"
                    class="form-control">
                  <div class="help-block" *ngIf="issued_date.invalid && (issued_date.dirty || issued_date.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 tx-red position-left"></i> Issued date is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-4" *ngIf="type.value != 'member'">
                <div class="form-group">
                  <span class="control-label"> Amount: </span>
                  <input type="number" name="amount" formControlName="amount" placeholder="Amount" class="form-control"
                    (ngModelChange)="calculateReceiptTotal()" required>
                  <div class="help-block" *ngIf="amount.invalid && (amount.dirty || amount.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 tx-red position-left"></i> Amount is required
                    </p>
                  </div>
                </div>
              </div>



              <div class="col-md-2" *ngIf="type.value != 'member'">
                <div class="form-group">
                  <span class="control-label"> VAT (15%): </span>
                  <input type="number" readonly name="vat" readonly formControlName="vat" placeholder="VAT"
                    class="form-control" required>
                </div>

              </div>
            </div>

            <div class="row">

              <div class="col-md-6">
                <div class="form-group">
                  <span class="control-label"> Total: </span>
                  <input type="number" name="total" readonly formControlName="total" placeholder="Gross Total"
                    class="form-control" required>
                </div>
              </div>

              <div class="col-sm-6 required">
                <span class="control-label">Status: </span>
                <select name="status" required formControlName="status" class="form-control"
                  data-placeholder="Select ekub status">
                  <option selected disabled>Status:</option>
                  <option value="pending">Pending</option>
                  <option value="collected">Collected</option>
                  <option value="disposed">Disposed</option>
                </select>
                <div class="help-block" *ngIf="receiptStatus.invalid && (receiptStatus.dirty || receiptStatus.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Receipt status is required.
                  </p>
                </div>
              </div>


            </div>


            <div class="form-group">
              <div class="row">
                <div class="col-sm-12">
                  <label>&nbsp;</label>
                  <label>Remark:</label>
                  <textarea rows="5" cols="5" class="form-control" required name="remark" formControlName="remark"
                    placeholder="Additional information . . ."></textarea>
                </div>
              </div>
            </div>


            <div>
              <div class="row">
                <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFilesAdded($event)">
                  <ngx-dropzone-label>
                    <div>
                      <h6 style="color:gray;" translate>- Drop Receipt Picture(s) here </h6>
                    </div>
                  </ngx-dropzone-label>
                  <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                    [removable]="true" (removed)="onRemove(f)">
                  </ngx-dropzone-image-preview>
                </div>

              </div><br>
            </div>


          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
            <button (click)="addReceipt(receipt.id)" data-dismiss="modal" class="btn btn-rounded bg-slate-800"
              [disabled]="receiptForm.invalid || files.length == 0"><i class="icon-add position-left"></i><span
                *ngIf="receipt?.id">Update</span><span *ngIf="!receipt?.id">Add</span>
              Receipt</button>
          </div>
        </form>

      </div>
    </div>
  </div>
  <!-- /Receipt form modal -->


  <!-- Receipt Pictture modal -->
  <div id="receiptPicModal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">

      <img *ngIf="selectedReceipt" [src]="baseUrl+'assets/'+selectedReceipt+'/render'" width="400" height="650"
        class="img-thumb receipt-img" alt="">

    </div>
  </div>
  <!-- / Receipt Pictture modal -->